import type { EffectivePassInfo } from "@/types/pass";

// 10월 31일을 포함한다. 이용권 자체의 만료일을 연장하지는 않는다.
export const PERSONAL_QUIZ_GRACE_END = Date.parse("2026-11-01T00:00:00+09:00");
export const PERSONAL_QUIZ_GRACE_NOTICE =
  "기존 Premium·Complete 이용자의 나만의 시험지 이용은 2026년 10월 31일까지예요. 이용권이 먼저 만료되면 만료일까지 이용할 수 있어요. 기존 시험지와 풀이 기록은 보존돼요.";
export const PERSONAL_QUIZ_UNAVAILABLE_NOTICE =
  "나만의 시험지는 인텔리전스 혜택으로 전환 준비 중이에요. Premium·Complete 구매 이용자는 유효한 이용권으로 2026년 10월 31일까지 이용할 수 있으며, 무료체험은 제외돼요. 기존 시험지와 풀이 기록은 보존돼요.";

export function canUsePersonalQuiz(
  pass: Pick<EffectivePassInfo, "passType" | "isActive" | "isTrial">,
  now = Date.now(),
): boolean {
  if (!pass.isActive) return false;
  if (pass.passType === "intelligence") return true;
  return !pass.isTrial && now < PERSONAL_QUIZ_GRACE_END &&
    (pass.passType === "premium" || pass.passType === "complete");
}
